module.exports = __webpack_public_path__ + "img/avatar0.95d3c460.png";